<template>
  <div class="about-page column-me" :class="{'mobile-mode': isMobile}">
    <!-- Banner -->
    <div class="banner-section column-me center-all">
      <div class="section-content">
        <div class="banner-item">
          <img src="../../assets/img/about/bg_about.jpg" class="banner-bg" draggable="false">
          <div class="banner-content" v-if="!isMobile">
            <div class="column-me" v-if="nowLanguage==='zh-cn'||nowLanguage==='ja'">
              <img src="../../assets/img/about/about_title1.png" class="w660 h180 objScaleDown" draggable="false">
              <img src="../../assets/img/about/about_title2.png" class="w1000 h180 objScaleDown mT20" draggable="false">
            </div>
            <div v-else>
              <img src="../../assets/img/home/home_title12.png" class="w580 objContain" draggable="false">
            </div>
          </div>
          <div class="banner-content font-n" v-if="isMobile">
            <img src="../../assets/img/home/home_title_m.png" class="w380 objContain" draggable="false">
            <div class="font36 font-l mT10" v-if="$i18n.locale==='zh-cn'||$i18n.locale==='ja'">
              悦唯所至 繁复皆<span class="colorOrange">简</span>
            </div>
            <img src="../../assets/img/go.png" class="img70 objFitCover mT40" draggable="false">
          </div>
        </div>
      </div>
    </div>

    <div class="row-me row-center" v-if="isMobile">
      <div class="flex1 h10" style="background: #B2C2E3"></div>
      <div class="flex1 h10" style="background: #F7EEF3"></div>
    </div>
    <!-- 关于我们内容 -->
    <div class="column-me center-all">
      <div class="section-content column-me">
        <!-- 公司介绍 -->
        <div class="row-me row-center animate-section" style="margin-top:-200px;" ref="introSection">
          <div class="intro-left animate-slide-left" v-if="!isMobile">
            <img src="../../assets/img/about/组 147.png" style="width: 100%; height: 100%; object-fit: cover;"
                 draggable="false">
          </div>
          <div class="intro-right column-me mT120 posRelative animate-slide-right">
            <div class="section-badge" v-if="!isMobile">
              <img src="../../assets/img/home/go.png" class="img30" draggable="false">
              <span class="mL10">{{ $t('nav.aboutUs') }}</span>
            </div>
            <div class="column-me mL60" v-if="isMobile">
              <img src="../../assets/img/about/组%2068.png" class="img45 objContain" draggable="false">
              <span class="font-db font36 mT15">{{ $t('about.aboutYuewei') }}</span>
            </div>
            <div class="intro-text rich-text mT30 zIndex10" v-if="introContent"
                 v-html="this.$method.formatRichText(introContent)"></div>
            <div class="row-me flex-end1 mB60 mT50" v-if="isMobile">
              <div class="btn-go-prize pointer row-me center-all" @click="clickPrize">
                <div class="font21 font-n">{{ $t('prize.title') }}</div>
                <img src="../../assets/img/go.png" class="img30 objContain mL10" draggable="false">
              </div>
            </div>
            <img src="../../assets/img/about/矩形%2041.png" class="h680 posLB objContain" draggable="false"
                 v-if="isMobile">
          </div>
        </div>
        <div v-if="!isMobile">
          <!-- 使命 -->
          <div class="vision-section posRelative column-me flex-end2 mT100 animate-section" style="margin-right: 30%"
               ref="visionSection">
            <div class="section-badge animate-fade-in">
              <img src="../../assets/img/home/go.png" class="img30" draggable="false">
            </div>
            <div class="font24 colorBlue mT10 font-l">{{ $t('about.mission') }}</div>
            <div class="vision-title row-me mT40 font-n">
              <img src="../../assets/img/yin.png" class="img30 objScaleDown mT10 mR10" draggable="false">
              {{ $t('about.missionText1') }}
            </div>
            <div class="vision-title">
              <span style="color: #EA8063;" class="font-sb">{{ $t('about.missionText2') }}</span>
            </div>
            <div class="vision-image mT60 animate-zoom-in">
              <img src="../../assets/img/about/蒙版组 4.png" style="width: 100%; height: 100%; object-fit: scale-down;"
                   draggable="false">
            </div>
          </div>
          <!-- 愿景 -->
          <div class="mission-section row-me row-center animate-section" ref="missionSection">
            <div class="mission-left animate-slide-left zIndex10">
              <div>
                <img src="../../assets/img/home/go.png" class="img30" draggable="false">
                <div class="font24 colorBlue mT10 font-l">{{ $t('about.vision') }}</div>
              </div>
              <div v-if="nowLanguage==='zh-cn'">
                <div class="mission-title mT40 font-n">
                  <span style="color: #EA8063;" class="font-sb">{{
                      $t('about.visionText1')
                    }}</span>{{ $t('about.visionText2') }}
                </div>
                <div class="mission-title row-me flex-end2 font-n">
                  <span style="color: #EA8063;" class="font-sb">{{
                      $t('about.visionText3')
                    }}</span>{{ $t('about.visionText4') }}
                  <img src="../../assets/img/yin1.png" class="img30 objScaleDown mL10 mB10" draggable="false">
                </div>
              </div>
              <div v-else>
                <div class="mission-title mT40 font-n">
                  <div style="color: #EA8063;" class="font-sb">{{ $t('about.visionText1') }}</div>
                  <div>{{ $t('about.visionText2') }}</div>
                </div>
                <div class="mission-title font-n">
                  <div style="color: #EA8063;" class="font-sb">{{ $t('about.visionText3') }}</div>
                  <div class="row-me flex-end2">
                    {{ $t('about.visionText4') }}
                    <img src="../../assets/img/yin1.png" class="img30 objScaleDown mL10 mB10" draggable="false">
                  </div>
                </div>
              </div>
            </div>
            <div class="flex1"></div>
            <div class="mission-right animate-slide-right">
              <img src="../../assets/img/about/xin.png" style="width: 100%; height: 100%; object-fit: scale-down;"
                   draggable="false">
            </div>
          </div>
          <!-- 价值观 -->
          <div class="values-section posRelative column-me flex-end2 mT100 animate-section" style="margin-right: 30%"
               ref="valuesSection">
            <div class="section-badge animate-fade-in">
              <img src="../../assets/img/home/go.png" class="img30" draggable="false">
            </div>
            <div class="font24 colorBlue mT10 font-l">{{ $t('about.values') }}</div>
            <div class="values-title row-me mT40 font-n">
              <img src="../../assets/img/yin.png" class="img30 objScaleDown mT10 mR10" draggable="false">
              {{ $t('about.valuesText1') }}
            </div>
            <div class="values-title font-n column-me flex-end2">
              <span>{{ $t('about.valuesText2') }}</span>
            </div>
            <div class="values-title font-n column-me flex-end2" v-if="nowLanguage==='zh-cn'">
              <div>{{ $t('about.valuesText3') }}</div>
              <span style="color: #EA8063;" class="font-sb">{{ $t('about.valuesText4') }}</span>
            </div>
            <div class="values-title font-n column-me flex-end2" v-else>
              <div>{{ $t('about.valuesText3') }}</div>
              <span style="color: #EA8063;" class="font-sb">{{ $t('about.valuesText4') }}</span>
            </div>
            <div class="values-image mT60 animate-zoom-in">
              <img src="../../assets/img/about/蒙版组 5.png" style="width: 100%; height: 100%; object-fit: scale-down;"
                   draggable="false">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {deviceState} from "@/utils/device";
import {getAboutIntro} from "@/http/api";
import bus from "@/assets/js/bus";
import {getLanguage} from "../../i18n";

export default {
  data() {
    return {
      deviceState,
      // 企业介绍内容（从API获取的富文本HTML）
      introContent: '',
      nowLanguage: '',
    }
  },
  computed: {
    isMobile() {
      return this.deviceState.isMobile
    }
  },
  created() {
    // 手机端初始化时检查可见区域
    if (this.isMobile) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.checkVisibleSections()
        }, 50)
      })
    }
    // 数据加载移到 activated 中，避免首次进入时重复调用
  },
  mounted() {
    this.nowLanguage = getLanguage()
    this.initScrollAnimation()
    // 确保页面加载时立即检查可见区域
    this.$nextTick(() => {
      this.checkVisibleSections()
    })
    // 监听语言切换事件
    bus.$on('language-changed', this.onLanguageChanged)
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect()
    }
    bus.$off('language-changed', this.onLanguageChanged)
  },
  activated() {
    // 重新加载数据
    this.loadAboutIntro()
    this.$nextTick(() => {
      this.resetAnimations()
      // 重新检查可见区域
      setTimeout(() => {
        this.checkVisibleSections()
      }, 100)
    })
  },
  methods: {
    // 语言切换时重新加载数据
    onLanguageChanged() {
      this.nowLanguage = getLanguage()
      this.loadAboutIntro()
    },
    // 加载企业介绍
    async loadAboutIntro() {
      try {
        const res = await getAboutIntro()
        if (res && res.code === 200 && res.data && res.data.content) {
          this.introContent = res.data.content
        }
      } catch (error) {
        console.error('加载企业介绍失败:', error)
      }
    },
    clickPrize() {
      this.$router.push({
        path: '/prize',
        query: {}
      })
    },
    // 重置所有动画
    resetAnimations() {
      const sections = [
        this.$refs.introSection,
        this.$refs.visionSection,
        this.$refs.missionSection,
        this.$refs.valuesSection
      ]

      sections.forEach(section => {
        if (section) {
          section.classList.remove('animate-in')
        }
      })

      this.$nextTick(() => {
        const bannerContent = document.querySelector('.banner-content')
        if (bannerContent) {
          bannerContent.style.animation = 'none'
          setTimeout(() => {
            bannerContent.style.animation = ''
          }, 10)
        }

        const fadeInElements = document.querySelectorAll('.animate-fade-in')
        fadeInElements.forEach(el => {
          el.style.animation = 'none'
          setTimeout(() => {
            el.style.animation = ''
          }, 10)
        })
      })
    },
    // 初始化滚动动画
    initScrollAnimation() {
      const options = {
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px'
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in')
          }
        })
      }, options)

      const sections = [
        this.$refs.introSection,
        this.$refs.visionSection,
        this.$refs.missionSection,
        this.$refs.valuesSection
      ]

      sections.forEach(section => {
        if (section) {
          this.observer.observe(section)
        }
      })
    },
    // 检查当前视口中可见的区块，立即触发它们的动画
    checkVisibleSections() {
      const sections = [
        this.$refs.introSection,
        this.$refs.visionSection,
        this.$refs.missionSection,
        this.$refs.valuesSection
      ]

      // 手机端直接触发所有动画，确保内容可见
      if (this.isMobile) {
        sections.forEach(section => {
          if (section) {
            section.classList.add('animate-in')
          }
        })
        return
      }

      sections.forEach(section => {
        if (section) {
          const rect = section.getBoundingClientRect()
          const windowHeight = window.innerHeight || document.documentElement.clientHeight
          const threshold = 0.85

          // 如果元素在视口中或接近视口
          if (rect.top < windowHeight * threshold && rect.bottom > 0) {
            section.classList.add('animate-in')
          }
        }
      })
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        if (to.path === '/aboutUs' && from && from.path !== '/aboutUs') {
          setTimeout(() => {
            this.resetAnimations()
            window.scrollTo({top: 0, behavior: 'smooth'})
            // 重新检查可见区域并触发动画
            this.$nextTick(() => {
              this.checkVisibleSections()
            })
          }, 50)
        }
      },
      immediate: false
    }
  }
}
</script>

<style lang="scss" scoped>
.about-page {
  width: 100%;
  scroll-behavior: smooth;
  overflow: hidden;

  .btn-go-prize {
    padding: 10px 15px;
    background: #EDEDF1;
    border-radius: 50px;
  }
}

// 滚动动画
.animate-section {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;

  &.animate-in {
    opacity: 1;
    transform: translateY(0);
  }
}

// 淡入动画
.animate-fade-in {
  opacity: 0;
  animation: fadeIn 1s ease-out 0.3s both;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

// 左侧滑入动画
.animate-slide-left {
  opacity: 0;
  transform: translateX(-60px);
  transition: all 0.8s ease-out 0.2s;
}

// 右侧滑入动画
.animate-slide-right {
  opacity: 0;
  transform: translateX(60px);
  transition: all 0.8s ease-out 0.4s;
}

// 当父元素有 animate-in 类时触发子元素动画
.animate-section.animate-in {
  .animate-slide-left,
  .animate-slide-right {
    opacity: 1;
    transform: translateX(0);
  }
}

// Banner 进入动画
.banner-section {
  .banner-content {
    animation: fadeInUp 1.2s ease-out 0.3s both;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(60px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 缩放进入动画
.animate-zoom-in {
  opacity: 0;
  transform: scale(0.8);
  transition: all 0.8s ease-out 0.6s;
}

.animate-section.animate-in {
  .animate-zoom-in {
    opacity: 1;
    transform: scale(1);
  }
}

.section-badge {
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: 500;
  color: #013D5C;

  .badge-icon {
    width: 20px;
    height: 20px;
  }
}

// 公司介绍样式
.intro-left {
  width: 720px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
}

.intro-right {
  flex: 1;
  font-family: font-l, serif;
  margin-left: 50px;

  .intro-text {
    width: 700px;
    font-size: 18px;
    color: #013D5C;
    line-height: 1.8;
    text-align: justify;
    word-break: break-word;

    :deep(p) {
      margin: 0;
      min-height: 1em;
    }

    :deep(img) {
      max-width: 100%;
      height: auto;
    }
  }
}

// 企业愿景样式
.vision-section {
  height: 600px;

  .vision-title {
    font-size: 48px;
    color: #013D5C;
    text-align: center;
    line-height: 1.5;
  }

  .vision-image {
    width: 1284px;
    height: 537px;
    border-radius: 8px;
    overflow: hidden;
    position: absolute;
    left: 0;
    bottom: 0;
  }
}

// 企业使命样式
.mission-section {
  width: 100%;
  position: relative;

  .mission-left {
    position: absolute;
    left: 30%;

    .mission-title {
      font-size: 48px;
      color: #013D5C;
      line-height: 1.5;
    }
  }

  .mission-right {
    width: 1050px;
    height: 765px;
    flex-shrink: 0;
  }
}

// 企业价值观
.values-section {
  height: 600px;

  .values-title {
    font-size: 48px;
    color: #013D5C;
    text-align: center;
    line-height: 1.5;
    z-index: 100;
  }

  .values-image {
    width: 1023px;
    height: 690px;
    border-radius: 8px;
    overflow: hidden;
    position: absolute;
    left: 0;
    bottom: 0;
  }
}

// ==================== 手机端适配样式 ====================
.about-page.mobile-mode {
  // Banner 适配 - 与首页保持一致
  .banner-section {
    .section-content {
      width: 100% !important;
      padding: 0 !important;
    }

    .banner-item {
      position: relative;
      width: 100%;
      height: 1020px;
      aspect-ratio: 16 / 9;
      overflow: hidden;

      .banner-bg {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .banner-content {
        position: absolute;
        top: 25%;
        left: 8%;
        display: flex;
        flex-direction: column;
        font-size: 87px;
        line-height: 80px;
        color: #454F5E;
      }
    }
  }

  // 内容区域适配
  .section-content {
    width: 100% !important;
    box-sizing: border-box;
  }

  // 公司介绍区域
  .animate-section:first-of-type {
    margin-top: 20px !important;
    flex-direction: column;

    .intro-left {
      width: 100%;
      height: auto;
      margin-bottom: 20px;
      position: absolute;
      left: 0;
      bottom: 0;
      object-fit: cover;
      object-position: right;

      img {
        width: 60% !important;
        height: 100% !important;
      }
    }

    .intro-right {
      padding-right: 60px !important;
      margin-top: 20px !important;
      margin-left: 0 !important;

      .section-badge {
        margin-left: 60px;

        .img30 {
          width: 50px !important;
          height: 50px !important;
          object-fit: cover !important;
        }

        span {
          font-size: 36px !important;
        }
      }

      .intro-text {
        width: auto !important;
        font-size: 24px !important;
        margin-top: 30px !important;
        color: #454F5E !important;
        margin-left: 60px;
      }
    }
  }

  // 使命区域
  .vision-section {
    height: auto !important;
    margin-top: 40px !important;
    margin-right: 60px !important;
    padding: 20px 0;

    .section-badge {
      .img30 {
        width: 50px !important;
        height: 50px !important;
        object-fit: cover !important;
      }
    }

    .font24 {
      font-size: 50px !important;
    }

    .vision-title {
      font-size: 40px !important;

      .img30 {
        width: 20px !important;
        height: 20px !important;
        margin-top: 5px !important;
      }
    }

    .vision-image {
      position: relative !important;
      width: 100% !important;
      height: auto !important;
      margin-top: -150px !important;
    }
  }

  // 愿景区域
  .mission-section {
    flex-direction: column !important;
    margin-top: 100px !important;

    .mission-left {
      position: relative !important;
      left: 60px !important;
      width: 100%;
      box-sizing: border-box;
      z-index: 1;

      .img30 {
        width: 50px !important;
        height: 50px !important;
        object-fit: cover !important;
      }

      .font24 {
        font-size: 50px !important;
      }

      .mission-title {
        font-size: 40px !important;

        .img30 {
          width: 20px !important;
          height: 20px !important;
          margin-left: 5px !important;
          margin-bottom: 15px !important;
        }
      }
    }

    .flex1 {
      display: none;
    }

    .mission-right {
      width: 100% !important;
      height: auto !important;
      margin-top: -350px;

      img {
        object-position: right;
      }
    }
  }

  // 价值观区域
  .values-section {
    height: auto !important;
    margin-top: 40px !important;
    margin-right: 60px !important;
    padding: 20px 0;

    .section-badge {
      .img30 {
        width: 50px !important;
        height: 50px !important;
        object-fit: cover !important;
      }
    }

    .font24 {
      font-size: 50px !important;
    }

    .values-title {
      font-size: 40px !important;

      .img30 {
        width: 30px !important;
        height: 30px !important;
        margin-top: 5px !important;
      }
    }

    .values-image {
      position: relative !important;
      width: 100% !important;
      height: auto !important;
      margin-top: -50px !important;
    }
  }
}
</style>
